import { Button, Drawer, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import toastr from "toastr";
import { client2 } from "../../operationalRequest";
import EditAttributeComponents from "./EditAttributeComponent";
import EditIotComponent from "./EditIotComponent";
import EditAlitiqComponent from "./EditAlitiqComponent";
import EditButton from "../../components/button/EditButton";
import ControlDevice from "./ControlDevice";

type EditIotProps = {
    data: any;
    mutate?: any;
};
const EditIot: React.FC<EditIotProps> = ({ data, mutate }) => {
    const [open, setOpen] = useState(false);
    const [attributes, setAttributes] = useState({} as any);
    const [loading, setLoading] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const editIot = async (values: any) => {
        try {
            if (loading) return;
            setLoading((curr: any) => true);
            const response = await client2.put(
                `api/system-device/${data?.id}`,
                {
                    systemdevice: values,
                },
            );
            if (response.status === 200) {
                mutate({ data: "data" });
                setOpen(false);
                toastr.success("Device Updated Successfully");
            }
        } catch (e: any) {
            console.log(e);
        }
        setLoading((curr: any) => false);
    };

    const editAttribute = async (values: any) => {
        try {
            if (loading) return;
            setLoading((curr: any) => true);
            const response = await client2.put(
                `api/system-device/${data?.id}`,
                {
                    systemdevice: values,
                },
            );
            if (response.status === 200) {
                mutate({ data: response.data });
                setOpen(false);
                toastr.success("Device Attribute Updated Successfully");
            }
        } catch (e: any) {
            console.log(e);
        }
        setLoading((curr: any) => false);
    };

    const editAlitiq = async (values: any) => {
        try {
            if (loading) return;
            setLoading((curr: any) => true);
            let response = {} as any;
            if (!values.id) {
                response = await client2.post(`api/alitiq`, {
                    ...values,
                    system_device_id: data.id,
                });
            } else {
                // response = await client2.put(`api/alitiq/${data?.id}`, {
                //     ...values,
                //     system_device_id: data.id
                // });
                toastr.error("Update is disabled. Please contact provider.");
            }
            if (response.status === 200) {
                mutate({ data: "data" });
                setOpen(false);
                toastr.success("Forecast Updated Successfully!");
            }
        } catch (e: any) {
            console.log(e);
        }
        setLoading((curr: any) => false);
    };

    return (
        <>
            <EditButton onClick={showDrawer} title="Edit Device" />
            <Drawer
                size="large"
                title="Edit Device"
                onClose={onClose}
                open={open}
            >
                <Tabs
                    defaultActiveKey="1"
                    items={[
                        {
                            label: "Device",
                            key: "1",
                            children: (
                                <EditIotComponent
                                    loading={loading}
                                    initialValue={{
                                        ...data,
                                        location_id: data.location_id && data.location_type
                                            ? `${data.location_id}|${data.location_type}`
                                            : null
                                    }}
                                    onSubmit={editIot}
                                />
                            ),
                        },
                        ...(data?.device_type === 10 || data?.device_type === 70
                            ? [
                                {
                                    label: "Forecast",
                                    key: "2",
                                    children: (
                                        <EditAlitiqComponent
                                            loading={loading}
                                            initialValue={{
                                                system_device_id: data.id,
                                                alitiq_enable:
                                                    data.alitiq_enable,
                                                ...data.location?.attributes,
                                                ...data.alitiq,
                                                ...(!!data?.alitiq
                                                    ?.config && {
                                                    subsystem:
                                                        data.alitiq.config,
                                                }),
                                            }}
                                            onSubmit={editAlitiq}
                                        />
                                    ),
                                },
                            ]
                            : []),
                        ...(data?.manufacture_type === 1883
                            ? [
                                {
                                    label: "Action",
                                    key: "3",
                                    children: (
                                        <ControlDevice
                                            value={data}
                                        />
                                    ),
                                },
                            ]
                            : []),
                    ]}
                />
            </Drawer>
        </>
    );
};

export default EditIot;